export class Refund {
  numberOfRecords: string;
  document: string;
  documentType: string;
  valueTitle: string;
  claimValue: string;
  expiration: string;
  refundDate: string;
  refundValue: string;
  deductibleDate: string;
  deductibleValue: string;
  name: string;
  claimedDate: string;
  claimNumber: string;
  rn: string;
  guaranteedValue: string;
  limit: number;
  currentPage: number;
  totalRecords: number;
  totalPages: number;
  idTx: string;

  public static fromResponse(json: any): { refunds: Refund[], limit: number, currentPage: number, totalRecords: number, totalPages: number, idTx: string } {
    const refunds: Refund[] = json['REINTEGROS'].map((refundData: any) => {
      return {
        name: refundData['CLIENTE'],
        document: refundData['DOCUMENTO'],
        deductibleDate: refundData['FECHA_DEDUCIBLE'],
        claimedDate: refundData['FECHA_RECLAMADO'],
        refundDate: refundData['FECHA_REINTEGRO'],
        deductibleValue: refundData['MONTO_DEDUCIBLE'],
        refundValue: refundData['MONTO_REINTEGRO'],
        claimNumber: refundData['NUMERO_RECLAMACION'],
        numberOfRecords: refundData['N_REGISTROS'],
        rn: refundData['RN'],
        documentType: refundData['TIPO_DOCUMENTO'],
        valueTitle: refundData['TITULO_VALOR'],
        guaranteedValue: refundData['VALOR_GARANTIZADO'],
        claimValue: refundData['VALOR_RECLAMADO'],
        expiration: refundData['VENCIMIENTO'],
      };
    });

    return {
      refunds: refunds,
      limit: json['LIMITE'],
      currentPage: json['PAGINA_ACTUAL'],
      totalRecords: json['TOTAL_REGISTROS'],
      totalPages: json['NUMERO_PAGINAS'],
      idTx: json['id_tx']
    };
  }
}